/**
 * Standard attributes gotten from https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
 */
var CognitoPropertyKeys;
(function (CognitoPropertyKeys) {
    //Standard Attributes that we actually use
    CognitoPropertyKeys["cognitoID"] = "sub";
    CognitoPropertyKeys["email"] = "email";
    CognitoPropertyKeys["language"] = "locale";
    CognitoPropertyKeys["firstName"] = "given_name";
    CognitoPropertyKeys["lastName"] = "family_name";
    CognitoPropertyKeys["phone"] = "phone_number";
    CognitoPropertyKeys["preferredUsername"] = "preferred_username";
    CognitoPropertyKeys["groups"] = "cognito:groups";
    //Custom Attributes defined at pool creation time
    CognitoPropertyKeys["userID"] = "custom:userID";
    CognitoPropertyKeys["externalID"] = "custom:externalID";
    CognitoPropertyKeys["organizationId"] = "custom:organizationId";
    /*
        Unsupported standard attributes (https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html)
        address
        birthdate
        gender
        middle_name
        name
        nickname
        picture
        profile
        updated_at
        website
        zoneinfo
    */
})(CognitoPropertyKeys || (CognitoPropertyKeys = {}));
export { CognitoPropertyKeys as UserPropertyKeys };
